import { useState } from "react";
import { useNavigate, useParams } from "react-router";

import { Page } from "@digital-services/shell";
import {
  Button,
  Card,
  IOption,
  MultiSelect,
  Select,
  Typography,
  useAlert
} from "@digital-services/ui";

import { apiUsersRoute, editApiUserRouteOnTab2 } from "@api-users/common";
import {
  generateApplicationsAsOptions,
  generateAppRolesAsOptions
} from "@api-users/part-3-app-roles/mocks/app-roles.gen";
import { useAddAppRoles } from "@api-users/part-3-app-roles/services/use-add-app-roles";

import PlusIcon from "@icons/plus.svg?react";

export const ManageAppRolesPage = () => {
  const navigate = useNavigate();
  const { notifyError, notifySuccess } = useAlert();
  const { apiUserId } = useParams();

  const [apiApplication, setApiApplication] = useState<IOption | null>(null);
  const [apiRole, setApiRole] = useState<IOption[] | null>(null);

  const [saveDisabled, setSaveDisabled] = useState(true);
  const [inProgress, setInProgress] = useState(false);

  const { addAppRoles } = useAddAppRoles();

  const onAddAppRolesCallback = async () => {
    if (!apiApplication || !apiRole) {
      return;
    }

    setSaveDisabled(true);
    setInProgress(true);

    const response = await addAppRoles(
      apiUserId!,
      String(apiApplication.value),
      apiRole.map(({ value }) => String(value))
    );

    // TEMP
    navigate(editApiUserRouteOnTab2(apiUserId!));

    if (response?.isSuccess) {
      notifySuccess({
        header: "Application role(s) has been successfully added",
        "data-testid": "app-app-role-success"
      });
      navigate(editApiUserRouteOnTab2(apiUserId!));
    } else {
      notifyError({
        header: "Could not add application role(s)",
        "data-testid": "add-app-role-error"
      });
    }
  };

  return (
    <Page title={"Add application roles for API user"}>
      <div className="flex justify-end gap-6">
        <Button
          variant="ghost"
          size="big"
          onClick={() => {
            navigate(apiUsersRoute);
          }}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          size="big"
          disabled={saveDisabled}
          isLoading={inProgress}
          onClick={onAddAppRolesCallback}
        >
          Add application roles
        </Button>
      </div>

      <div className="flex">
        <Card className="w-[50%]">
          <Typography variant="smallTitle">Details</Typography>
          <div className="mt-6">
            <Select
              id={"add-application-selector"}
              placeholder="Select application"
              onChange={val => {
                setApiApplication(val);
              }}
              options={generateApplicationsAsOptions()}
              selected={apiApplication}
            />
          </div>
          <div className="mt-6">
            <MultiSelect
              placeholder="Select role"
              onChange={val => {
                // yes, as soon as we select some role, we can then enable "Save"
                setSaveDisabled(false);
                setApiRole(val);
              }}
              options={generateAppRolesAsOptions()}
              selected={apiRole}
            />
          </div>
          {/* MAYBE DELETE */}
          <div className="mt-6 flex items-center justify-center">
            <Button
              variant="ghost"
              onClick={() => {
                // TBD
              }}
              icon={<PlusIcon />}
            >
              Add application
            </Button>
          </div>
          {/* MAYBE DELETE */}
        </Card>
      </div>
    </Page>
  );
};
